import { render } from "./CardGroupTile.vue?vue&type=template&id=7ff613f6&ts=true"
import script from "./CardGroupTile.vue?vue&type=script&lang=ts"
export * from "./CardGroupTile.vue?vue&type=script&lang=ts"

import "./CardGroupTile.vue?vue&type=style&index=0&id=7ff613f6&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__